jQuery(function ($) {

// mainVisual スライダー
$(document).ready(function () {
  $('#js-main-slider').slick({
		autoplaySpeed: 2000,
		autoplay: true,
		speed: 3000,
		dots: true,
		arrows: false,
	});
});

$(window).on('load', function() {
	if ($('#homeMainVisual .imgBox').length) {
		$('#homeMainVisual .imgBox').css({
			'background': 'none'
		});
	}
});

});
